import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import "./styles/sidebar.css";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MenuToogleIcon from "../assets/images/menu-tooglebar.png";
import Nabar from "./header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faList,
  faStore,
  faUsers,
  faBagShopping,
  faTicket,
  faFileAlt,
  faGear,
  faAddressBook,
  faShoppingCart,
  faTags,
  faDownload
} from "@fortawesome/free-solid-svg-icons";
import { useListColorThemeQuery } from "../Services/SettingsAPI"

function SidebarComponent({ handleChange }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Detect mobile

  const { data: ColorthemeData } = useListColorThemeQuery();

  console.log("ColorthemeData", ColorthemeData);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleSubMenuClick = (menuName) => {
    setActiveSubMenu((prev) => (prev === menuName ? null : menuName));
  };

  return (
    <>
      <Nabar />
      {isMobile && !isSidebarOpen && (
        <button className="toggle-btn" onClick={toggleSidebar}>
          <img src={MenuToogleIcon} alt="Menu Toggle Icon" width={30} />
        </button>
      )}

      <div className={`sidebar-container ${isSidebarOpen ? "open" : ""}`}>
        <Sidebar className="Sidebar">
          {isMobile && (
            <button className="close-btn" onClick={closeSidebar}>
              ×
            </button>
          )}

          <Menu>
            <MenuItem className="pl-5 logo-sec">
              {ColorthemeData?.color_themes?.[0]?.main_logo_url ? (
                <div className="logo-div">
                  <img src={ColorthemeData.color_themes[0].main_logo_url} alt="logo" className="img-fluid logo-img" />
                </div>

              ) : (
                <span className="logo">Logo</span>
              )}
            </MenuItem>


            <Link to="/" onClick={closeSidebar}>  <MenuItem className="pl-5">

              <FontAwesomeIcon
                icon={faTachometerAlt}
                className="mx-2"
                style={{ cursor: "pointer" }}
              /> Dashboard
            </MenuItem></Link>

            <Link to="/reports" onClick={closeSidebar}>  <MenuItem className="pl-5">

              <FontAwesomeIcon
                icon={faDownload}
                className="mx-2"
                style={{ cursor: "pointer" }}
              /> Download Reports
            </MenuItem></Link>

            <Link to="/list-category" onClick={closeSidebar}>  <MenuItem className="pl-5">

              <FontAwesomeIcon
                icon={faList}
                className="mx-2"
                style={{ cursor: "pointer" }}
              /> Category
            </MenuItem></Link>

            <Link to="/list-brands" onClick={closeSidebar}>  <MenuItem className="pl-5">
              <FontAwesomeIcon
                icon={faStore}
                className="mx-2"
                style={{ cursor: "pointer" }}
              />   Brands
            </MenuItem></Link>

            <Link to="/list-varients" onClick={closeSidebar}> <MenuItem className="pl-5">

              <FontAwesomeIcon
                icon={faTags}
                className="mx-2"
                style={{ cursor: "pointer" }}
              />   Add Variants
            </MenuItem></Link>

            <Link to="/products" onClick={closeSidebar}> <MenuItem className="pl-5">

              <FontAwesomeIcon
                icon={faBagShopping}
                className="mx-2"
                style={{ cursor: "pointer" }}
              />    Products
            </MenuItem></Link>


            <Link to="/coupon-list" onClick={closeSidebar}> <MenuItem className="pl-5">

              <FontAwesomeIcon
                icon={faTicket}
                className="mx-2"
                style={{ cursor: "pointer" }}
              />     Coupon
            </MenuItem></Link>


            <Link to="/order-list" onClick={closeSidebar}> <MenuItem className="pl-5">
              <FontAwesomeIcon
                icon={faShoppingCart}
                className="mx-2"
                style={{ cursor: "pointer" }}
              /> Orders
            </MenuItem></Link>
            <Link to="/customer-list" onClick={closeSidebar}> <MenuItem className="pl-5">
              <FontAwesomeIcon
                icon={faUsers}
                className="mx-2"
                style={{ cursor: "pointer" }}
              />  Customers
            </MenuItem></Link>
            <SubMenu
              label={
                <>
                  <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: "8px" }} />
                  Pages
                </>
              }
              open={activeSubMenu === "pages"}
              onClick={() => handleSubMenuClick("pages")}
            >
              <Link to="/home" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/home" ? "sub-menu-item-active" : ""}>
                  Home
                </MenuItem>
              </Link>
              <Link to="/about-section-add" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/huddlesession" ? "sub-menu-item-active" : ""}>
                  About
                </MenuItem>
              </Link>

              <Link to="/contact-add" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/contact" ? "sub-menu-item-active" : ""}>
                  Contact
                </MenuItem>
              </Link>

              <Link to="/privacy-policy" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/privacy-policy" ? "sub-menu-item-active" : ""}>
                  Privacy Policy
                </MenuItem>
              </Link>

              <Link to="/terms-and-conditions" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/terms-and-conditions" ? "sub-menu-item-active" : ""}>
                  Terms and Conditions
                </MenuItem>
              </Link>

              <Link to="/refund-policy" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/refund-policy" ? "sub-menu-item-active" : ""}>
                  Refund Policy
                </MenuItem>
              </Link>

              <Link to="/shipping-policy" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/shipping-policy" ? "sub-menu-item-active" : ""}>
                  shipping policy
                </MenuItem>
              </Link>

              <Link to="/other-banner-list" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/huddlesession" ? "sub-menu-item-active" : ""}>
                  Add  Banners
                </MenuItem>
              </Link>

            </SubMenu>
            <Link to="/inquiry-management" onClick={closeSidebar}> <MenuItem className="pl-5">

              <FontAwesomeIcon
                icon={faAddressBook}
                className="mx-2"
                style={{ cursor: "pointer" }}
              /> Inquiry Management
            </MenuItem></Link>
            <SubMenu
              label={
                <>
                  <FontAwesomeIcon icon={faGear} style={{ marginRight: "8px" }} />
                  Settings
                </>
              }
              open={activeSubMenu === "settings"}
              onClick={() => handleSubMenuClick("settings")}
            >
              <Link to="/general-settings" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/general-settings" ? "sub-menu-item-active" : ""}>
                  General
                </MenuItem>
              </Link>
              <Link to="/paymentmethod-list" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/payment-settings" ? "sub-menu-item-active" : ""}>
                  Payment
                </MenuItem>
              </Link>

              <Link to="/footer-settings" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/footer-settings" ? "sub-menu-item-active" : ""}>
                  Website Settings
                </MenuItem>
              </Link>

              <Link to="/enable-guest-checkout" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/enable-guest-checkout" ? "sub-menu-item-active" : ""} title="Enable/Disable Guestcheckout">
                  Checkout
                </MenuItem>
              </Link>

              <Link to="/update-currency" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/update-currency" ? "sub-menu-item-active" : ""} title="Currency">
                  Currency
                </MenuItem>
              </Link>


              <Link to="/order-settings" onClick={closeSidebar}>
                <MenuItem className={window.location.pathname === "/order-settings" ? "sub-menu-item-active" : ""}>
                  Flat Rate
                </MenuItem>
              </Link>

            </SubMenu>
          </Menu>


        </Sidebar>
      </div>
    </>
  );
}

export default SidebarComponent;
